import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "top" }
const _hoisted_2 = {
  key: 0,
  class: "left"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "inAppNotification",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.item.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.item.icon)))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "text",
        innerHTML: _ctx.item.text
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.date(_ctx.item.createdOn, 'DD-MM-YY HH:mm')), 1)
  ]))
}